exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body_howto {\n  padding: 20px; }\n  .body_howto .howto_cont_body {\n    padding-top: 0 !important; }\n    .body_howto .howto_cont_body .howto_cont_item_wrap:not(:first-of-type) {\n      margin-top: 50px; }\n    .body_howto .howto_cont_body .howto_cont_item_wrap .howto_cont_item_head > div:last-of-type {\n      font-size: 21px;\n      margin-left: 20px;\n      padding-top: 2px; }\n    .body_howto .howto_cont_body .howto_cont_item_wrap .howto_cont_item_body {\n      margin-top: 20px; }\n      .body_howto .howto_cont_body .howto_cont_item_wrap .howto_cont_item_body img {\n        margin: 0 auto; }\n", ""]);

// exports
